import { TQualityBand } from 'partner360/components/qualityIndicator'

/**
 * Green is represented by the shared High band; Low and Moderate require attention: their
 * details open, their section needs a justification and the review starts at the first of them.
 */
export const isBelowHighQuality = (band: TQualityBand | null) => band !== null && band !== 'High'
